import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AccountCards } from '../models/account';
import { CorporateCard } from '../models/corporate-card';
import { ContractApplication } from '$modules/personal/customer-card/models/contract';
import { Contract } from '$modules/personal/customer-card/models/card-aplication';

@Injectable({
  providedIn: 'root',
})
export class CardStorageService {
  public corporateCard$: BehaviorSubject<CorporateCard> =
    new BehaviorSubject<CorporateCard>(null);
  public application$ = new BehaviorSubject<ContractApplication>(null);
  public contract$ = new BehaviorSubject<Contract>(null);

  private _corporateCard: CorporateCard;
  public get corporateCard() {
    return this._corporateCard;
  }

  public set corporateCard(v) {
    this._corporateCard = v;
    this.corporateCard$.next(v);
  }

  public account: AccountCards;

  public validations$ = new Subject();

  private _contract: Contract;
  public get contract(): Contract {
    return this._contract;
  }

  public set contract(v: Contract) {
    this._contract = v;
    this.contract$.next(v);
  }

  private _application: ContractApplication;
  public get application(): ContractApplication {
    return this._application;
  }

  public set application(v: ContractApplication) {
    this._application = v;
    this.application$.next(v);
  }
}
